const skillsInfo = [
  {
    category: 'Languages',
    skills: ['Java', 'JavaScript', 'TypeScript', 'HTML', 'CSS / SCSS'],
  },
  {
    category: 'Frameworks & Libraries',
    skills: ['Spring Boot', 'React.js', 'Angular', 'Next.js', 'Node.js'],
  },
  {
    category: 'Infra & Systems',
    skills: ['Kafka', 'Kubernetes', 'Docker', 'MongoDB', 'REST APIs', 'CI/CD'],
  },
  {
    category: 'Tools & Practices',
    skills: ['Git', 'JUnit', 'k6 (Load Testing)', 'System Design', 'Agile / Scrum'],
  },
]

export default skillsInfo
